import React from "react";
import { ILibraryContentDto } from "../../interfaces/IUtilities";
import { useTranslation } from "react-i18next";

interface LibraryTreeModalProps {
    show: boolean;
    onClose: () => void;
    libraryPath: string | null;
    content: ILibraryContentDto | null;
    loading: boolean;
}

const LibraryTreeModal: React.FC<LibraryTreeModalProps> = ({
    show,
    onClose,
    libraryPath,
    content,
    loading
}) => {
    const { t } = useTranslation();

    const renderNode = (node: ILibraryContentDto) => {
        return (
            <li key={node.relativePath} className="mb-2">
                <div className="fw-semibold">{node.name}</div>
                {node.files?.length ? (
                    <ul className="list-unstyled ms-3 mb-1">
                        {node.files.map((file) => (
                            <li key={`${node.relativePath}/file-${file}`} className="text-muted">
                                {file}
                            </li>
                        ))}
                    </ul>
                ) : null}
                {node.folders?.length ? (
                    <ul className="list-unstyled ms-3">
                        {node.folders.map((child) => renderNode(child))}
                    </ul>
                ) : null}
            </li>
        );
    };

    if (!show) return null;

    return (
        <div className="modal d-block" tabIndex={-1} role="dialog" aria-modal="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {t("LibraryContents")} {libraryPath ? `- ${libraryPath}` : ""}
                        </h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {loading ? (
                            <div className="d-flex justify-content-center py-3">
                                <div className="spinner-border text-primary" role="status" aria-label={t("Loading")}>
                                    <span className="visually-hidden">{t("Loading")}</span>
                                </div>
                            </div>
                        ) : content ? (
                            <ul className="list-unstyled">
                                {renderNode(content)}
                            </ul>
                        ) : (
                            <p className="text-muted mb-0">{t("NoDataAvailable")}</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t("Close")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LibraryTreeModal;
